import { FieldInterface } from "@/types";
import { AVAILABLE_COUNTRIES } from "@/constants/country-settings";
import i18n from "@/i18n";
import Store from "@/store";

export class CountryHelper {
  /**
   * @param countries
   * @return FieldInterface[] Array of countries in order specified in PREFERRED_COUNTRIES array
   */
  public static orderCountries(countries: FieldInterface[]): FieldInterface[] {
    let result: FieldInterface[] = [];
    let localeCountry: FieldInterface[] = [];
    let aviableCountries: FieldInterface[] = [];

    countries.sort(function(a, b) {
      if (a.value < b.value) {
        return -1;
      }
      if (a.value > b.value) {
        return 1;
      }
      return 0;
    });

    countries.forEach(entry => {
      if (entry.key === i18n.locale.toUpperCase()) {
        localeCountry.push(entry);
      } else if (AVAILABLE_COUNTRIES.includes(entry.key.toString().toUpperCase())) {
        aviableCountries.push(entry);
      } else {
        result.push(entry);
      }
    });

    return [...localeCountry, ...aviableCountries, ...result];
  }

  public static isEuropeanCountry(country: string) {
    return Store.state.config.europeanCountries.includes(country);
  }
}
